import { Action } from '@ngrx/store';
import { Camera } from '../../api/models/camera';

export const LOAD_CAMERAS = '[Cameras] Load Cameras';
export const LOAD_CAMERAS_SUCCESS = '[Cameras] Load Cameras Success';
export const LOAD_CAMERAS_FAIL = '[Cameras] Load Cameras Fail';

export const UPDATE_CAMERA = '[Cameras] Update Camera';


// Action Classes
export class LoadCameras implements Action {
  readonly type = LOAD_CAMERAS;
}

export class LoadCamerasSuccess implements Action {
  readonly type = LOAD_CAMERAS_SUCCESS;
  constructor(public payload: Camera[]) {}
}

export class LoadCamerasFail implements Action {
  readonly type = LOAD_CAMERAS_FAIL;
}

export class UpdateCamera implements Action {
  readonly type = UPDATE_CAMERA;
  constructor(public payload: Camera) {}
}



export type CamerasAction =
  | LoadCameras
  | LoadCamerasSuccess
  | LoadCamerasFail
  | UpdateCamera
